module.exports = __webpack_public_path__ + "img/0Q3A7086_L_Foamcore.60a59906.jpg";